/* eslint-disable */
// source: vivacity/config/hardware_position_drawing.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var vivacity_core_point_pb = require('../../vivacity/core/point_pb.js');
goog.object.extend(proto, vivacity_core_point_pb);
goog.exportSymbol('proto.vivacity.config.HardwarePositionDrawing', null, global);
goog.exportSymbol('proto.vivacity.config.HardwarePositionDrawing.HardwarePositionDrawingType', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vivacity.config.HardwarePositionDrawing = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vivacity.config.HardwarePositionDrawing.repeatedFields_, null);
};
goog.inherits(proto.vivacity.config.HardwarePositionDrawing, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vivacity.config.HardwarePositionDrawing.displayName = 'proto.vivacity.config.HardwarePositionDrawing';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vivacity.config.HardwarePositionDrawing.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vivacity.config.HardwarePositionDrawing.prototype.toObject = function(opt_includeInstance) {
  return proto.vivacity.config.HardwarePositionDrawing.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vivacity.config.HardwarePositionDrawing} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.config.HardwarePositionDrawing.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    hardwarePositionId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    coordinatesList: jspb.Message.toObjectList(msg.getCoordinatesList(),
    vivacity_core_point_pb.PointF.toObject, includeInstance),
    closed: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    name: jspb.Message.getFieldWithDefault(msg, 5, ""),
    colour: jspb.Message.getFieldWithDefault(msg, 6, ""),
    drawingType: jspb.Message.getFieldWithDefault(msg, 7, 0),
    correlationId: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vivacity.config.HardwarePositionDrawing}
 */
proto.vivacity.config.HardwarePositionDrawing.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vivacity.config.HardwarePositionDrawing;
  return proto.vivacity.config.HardwarePositionDrawing.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vivacity.config.HardwarePositionDrawing} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vivacity.config.HardwarePositionDrawing}
 */
proto.vivacity.config.HardwarePositionDrawing.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setHardwarePositionId(value);
      break;
    case 3:
      var value = new vivacity_core_point_pb.PointF;
      reader.readMessage(value,vivacity_core_point_pb.PointF.deserializeBinaryFromReader);
      msg.addCoordinates(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setClosed(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setColour(value);
      break;
    case 7:
      var value = /** @type {!proto.vivacity.config.HardwarePositionDrawing.HardwarePositionDrawingType} */ (reader.readEnum());
      msg.setDrawingType(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorrelationId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vivacity.config.HardwarePositionDrawing.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vivacity.config.HardwarePositionDrawing.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vivacity.config.HardwarePositionDrawing} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.config.HardwarePositionDrawing.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getHardwarePositionId();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getCoordinatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      vivacity_core_point_pb.PointF.serializeBinaryToWriter
    );
  }
  f = message.getClosed();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getColour();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getDrawingType();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getCorrelationId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.vivacity.config.HardwarePositionDrawing.HardwarePositionDrawingType = {
  UNKNOWN: 0,
  COUNTLINE_NORMAL: 1,
  COUNTLINE_SPEED: 2,
  COUNTLINE_ANPR: 3,
  ZONE_SPEED: 4,
  ZONE_OCCUPANCY: 5,
  ZONE_DWELL_TIME: 6,
  ZONE_TURNING_COUNT: 7,
  ZONE_NEAR_MISS: 8,
  GENERIC_POLYLINE: 9
};

/**
 * optional uint32 id = 1;
 * @return {number}
 */
proto.vivacity.config.HardwarePositionDrawing.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.config.HardwarePositionDrawing} returns this
 */
proto.vivacity.config.HardwarePositionDrawing.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 hardware_position_id = 2;
 * @return {number}
 */
proto.vivacity.config.HardwarePositionDrawing.prototype.getHardwarePositionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.config.HardwarePositionDrawing} returns this
 */
proto.vivacity.config.HardwarePositionDrawing.prototype.setHardwarePositionId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated vivacity.core.PointF coordinates = 3;
 * @return {!Array<!proto.vivacity.core.PointF>}
 */
proto.vivacity.config.HardwarePositionDrawing.prototype.getCoordinatesList = function() {
  return /** @type{!Array<!proto.vivacity.core.PointF>} */ (
    jspb.Message.getRepeatedWrapperField(this, vivacity_core_point_pb.PointF, 3));
};


/**
 * @param {!Array<!proto.vivacity.core.PointF>} value
 * @return {!proto.vivacity.config.HardwarePositionDrawing} returns this
*/
proto.vivacity.config.HardwarePositionDrawing.prototype.setCoordinatesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.vivacity.core.PointF=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vivacity.core.PointF}
 */
proto.vivacity.config.HardwarePositionDrawing.prototype.addCoordinates = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.vivacity.core.PointF, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vivacity.config.HardwarePositionDrawing} returns this
 */
proto.vivacity.config.HardwarePositionDrawing.prototype.clearCoordinatesList = function() {
  return this.setCoordinatesList([]);
};


/**
 * optional bool closed = 4;
 * @return {boolean}
 */
proto.vivacity.config.HardwarePositionDrawing.prototype.getClosed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vivacity.config.HardwarePositionDrawing} returns this
 */
proto.vivacity.config.HardwarePositionDrawing.prototype.setClosed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional string name = 5;
 * @return {string}
 */
proto.vivacity.config.HardwarePositionDrawing.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.vivacity.config.HardwarePositionDrawing} returns this
 */
proto.vivacity.config.HardwarePositionDrawing.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string colour = 6;
 * @return {string}
 */
proto.vivacity.config.HardwarePositionDrawing.prototype.getColour = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.vivacity.config.HardwarePositionDrawing} returns this
 */
proto.vivacity.config.HardwarePositionDrawing.prototype.setColour = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional HardwarePositionDrawingType drawing_type = 7;
 * @return {!proto.vivacity.config.HardwarePositionDrawing.HardwarePositionDrawingType}
 */
proto.vivacity.config.HardwarePositionDrawing.prototype.getDrawingType = function() {
  return /** @type {!proto.vivacity.config.HardwarePositionDrawing.HardwarePositionDrawingType} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.vivacity.config.HardwarePositionDrawing.HardwarePositionDrawingType} value
 * @return {!proto.vivacity.config.HardwarePositionDrawing} returns this
 */
proto.vivacity.config.HardwarePositionDrawing.prototype.setDrawingType = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional string correlation_id = 8;
 * @return {string}
 */
proto.vivacity.config.HardwarePositionDrawing.prototype.getCorrelationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.vivacity.config.HardwarePositionDrawing} returns this
 */
proto.vivacity.config.HardwarePositionDrawing.prototype.setCorrelationId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


goog.object.extend(exports, proto.vivacity.config);
